/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Gallery_DescriptionInputs */

const en_directory_ai_tools_gallery_description = /** @type {(inputs: Directory_Ai_Tools_Gallery_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two photos and a one-line topic in, a 12-second clip out. Tap a clip to hear it.`)
};

const zh_directory_ai_tools_gallery_description = /** @type {(inputs: Directory_Ai_Tools_Gallery_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两张照片加一句主题，生成一条 12 秒短片。点开即可听声音。`)
};

/**
* | output |
* | --- |
* | "Two photos and a one-line topic in, a 12-second clip out. Tap a clip to hear it." |
*
* @param {Directory_Ai_Tools_Gallery_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_gallery_description = /** @type {((inputs?: Directory_Ai_Tools_Gallery_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Gallery_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_gallery_description(inputs)
	return zh_directory_ai_tools_gallery_description(inputs)
});
export { directory_ai_tools_gallery_description as "directory.ai_tools.gallery_description" }